import * as Yup from 'yup'

export const DomainSchema = Yup.object().shape({
  domain: Yup.string().required('domainErr'),
})
